import React from 'react';
import '../assets/css/main.css';
import '../assets/css/nice-select2.css';
import '../assets/css/swiper-bundle.min.css';
import { Link } from "react-router-dom";
import withRouter from '../WithRouter';
import UnloggedHeader from '../Headers/UnloggedHeader';
import {Notice, initForms, initLayoutScripts, getDatesSwipers} from '../assets/js/notice.js'
import doctor_preview from '../assets/img/doctor-preview.png'
import logo from '../assets/img/logo.png'
import Icon from 'react-icons-kit';
import {x} from 'react-icons-kit/feather/x';
import vk_logo from '..//assets/img/vk.svg'
import tg_logo from '..//assets/img/telegram.svg'

let was_inited = false;
let schedule = {};

const page_size_default = 15;
let page_size = page_size_default;

const UNAUTHED_TOKEN = "100001100011000011111010001000010";

class Enroll extends React.Component {
    constructor(props) {
        super(props);

        this.state = { loading: false, events: [], error_messages: [], business_units: {}, selected_business_unit_id: 0, selected_date: "", specializations: [],
                        selected_specialization_id: 0, services: [], selected_service_id: 0, selected_service_id_second: 0, doctors: [], selected_doctor_id: -1, united: {},
                        search: "", search_applied: "", router: props.router, need_to_init: false, bus_uids: {}, srvs_ids: {}, emp_uids: {}, prices: {}, open_description_for_doctor: 0,
                        business_unit_filter_search: "", business_unit_filter_observer: {}, specialization_filter_search: "", specialization_filter_observer: {},
                        service_filter_search: "", service_filter_observer: {}, current_page: 1 };

        //Если пользователь авторизован как специалист, удаляем обычный токен и меняем страницу
        if(localStorage.getItem('empAccessToken'))
        {
            localStorage.removeItem('accessToken')
            window.location = "/empschedule";
        }

        //Если пользователь авторизован, перенаправляем его на страницу записи авторизованных пользователей
        if(localStorage.getItem('accessToken'))
            window.location = "/appointment" + this.constructLinkParams();
    }

    componentDidUpdate(prevProps) {
        //Если есть ошибки, выводим всплывающее окно с ними
        if(this.state.error_messages.length > 0)
            Notice.show(this.state.error_messages.join('<br/>'));
        if(prevProps.router !== this.props.router)
            this.setState({router: this.props.router});

        if(this.state.need_to_init)
        {
            //Инициализируем скрипты от верстальщиков
            if(was_inited)
                initLayoutScripts();
            was_inited = true;
            initLayoutScripts();
            Notice.setHideCallback(() => { this.setState({error_messages: []}); this.setState({error_messages: []}); });
            this.setState({need_to_init: false});
        }

        //Вызываем обработчик скролла
        this.handleScroll();

        //При необходимости сбрасываем параметры модального окна описания врача
        const form = document.getElementById("doctor_description");
        if(form)
            if(this.state.open_description_for_doctor != 0)
                if(!form.classList.contains('open'))
                    this.setState({open_description_for_doctor: 0});
    }

    componentDidMount() {
        document.title = "Запись - Здоровый ребенок";

        window.addEventListener('scroll', this.handleScroll);

        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Счетчик обработанных запросов
        const requests_to_fetch = 1;
        let requests_processed = 0;

        //Запрашиваем события для карусели
        let events = [];
        fetch('/api/get-slider?code=1000001', {method: 'GET', headers:{'ZR-Access-Token': UNAUTHED_TOKEN}})
            .then(response => response.json())
            .then(data => {
                //Парсим данные
                events = data;
                this.setState({ events: data });

                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);
            })
            .catch((error) => {
                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });

        //Устанавливаем отслеживатель изменений DOM для фильтра бизнес-подразделений
        const business_unit_filter_node = document.getElementById("with-dropdown-business");
        if(business_unit_filter_node)
        {
            // Создаем MutationObserver для отслеживания изменений
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class')
                    {
                        if(business_unit_filter_node.classList.contains('open'))
                        {
                            //Ставим фокус на поиске при открытии (но не для мобильной версии)
                            if (window.innerWidth > 992)
                            {
                                const filterSearchInput = business_unit_filter_node.querySelector('.filter-search');
                                if(filterSearchInput)
                                    filterSearchInput.focus();
                            }
                        }
                        else
                        {
                            //Сбрасываем поиск при закрытии блока
                            if(this.state.business_unit_filter_search != "")
                                this.setState({ business_unit_filter_search: "" });
                        }
                    }
                }
            });

            // Начинаем наблюдение за изменениями атрибутов
            observer.observe(business_unit_filter_node, {
                attributes: true, // Отслеживаем изменения атрибутов
            });

            // Сохраняем наблюдатель для очистки
            this.setState({business_unit_filter_observer: observer});
        }

        //Устанавливаем отслеживатель изменений DOM для фильтра специализаций
        const specialization_filter_node = document.getElementById("with-dropdown-specialization");
        if(specialization_filter_node)
        {
            // Создаем MutationObserver для отслеживания изменений
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class')
                    {
                        if(specialization_filter_node.classList.contains('open'))
                        {
                            //Ставим фокус на поиске при открытии (но не для мобильной версии)
                            if (window.innerWidth > 992)
                            {
                                const filterSearchInput = specialization_filter_node.querySelector('.filter-search');
                                if(filterSearchInput)
                                    filterSearchInput.focus();
                            }
                        }
                        else
                        {
                            //Сбрасываем поиск при закрытии блока
                            if(this.state.specialization_filter_search != "")
                                this.setState({ specialization_filter_search: "" });
                        }
                    }
                }
            });

            // Начинаем наблюдение за изменениями атрибутов
            observer.observe(specialization_filter_node, {
                attributes: true, // Отслеживаем изменения атрибутов
            });

            // Сохраняем наблюдатель для очистки
            this.setState({specialization_filter_observer: observer});
        }

        //Устанавливаем отслеживатель изменений DOM для фильтра услуг
        const service_filter_node = document.getElementById("with-dropdown-service");
        if(service_filter_node)
        {
            // Создаем MutationObserver для отслеживания изменений
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class')
                    {
                        if(service_filter_node.classList.contains('open'))
                        {
                            //Ставим фокус на поиске при открытии (но не для мобильной версии)
                            if (window.innerWidth > 992)
                            {
                                const filterSearchInput = service_filter_node.querySelector('.filter-search');
                                if(filterSearchInput)
                                    filterSearchInput.focus();
                            }
                        }
                        else
                        {
                            //Сбрасываем поиск при закрытии блока
                            if(this.state.service_filter_search != "")
                                this.setState({ service_filter_search: "" });
                        }
                    }
                }
            });

            // Начинаем наблюдение за изменениями атрибутов
            observer.observe(service_filter_node, {
                attributes: true, // Отслеживаем изменения атрибутов
            });

            // Сохраняем наблюдатель для очистки
            this.setState({service_filter_observer: observer});
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);

        //Отключаем отслеживатели изменений DOM
        if(Object.keys(this.state.business_unit_filter_observer).length !== 0)
            this.state.business_unit_filter_observer.disconnect();
        if(Object.keys(this.state.specialization_filter_observer).length !== 0)
            this.state.specialization_filter_observer.disconnect();
        if(Object.keys(this.state.service_filter_observer).length !== 0)
            this.state.service_filter_observer.disconnect();
    }

    get_events_images = (events_original) => {
        //Если event`ов нет, выходим
        if(events_original.length === 0)
        {
            this.setState({loading: false, need_to_init: true});
            this.setState({united: {}});
            this.get_bus();
            return;
        }

        let events = events_original;
        let events_quantity = events_original.length;
        let events_processed = 0;
        for(let even_t of events)
        {
            //Запрашиваем аватар
            fetch('/api/GetImageById', {method: 'POST', headers:{'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN},
                body: JSON.stringify({ "imgId": even_t.file_id })})
                .then(response => response.json())
                .then(data => {
                    //Выключаем анимацию загрузки, если все запросы обработаны
                    if(++events_processed >= events_quantity)
                        this.setState({loading: false, need_to_init: true});

                    //Проверяем наличие обязательных полей в ответе
                    if(!('result' in data) || !('body' in data))
                        return;
                    else
                    {
                        //В случае ошибки добавляем ее в состояние
                        if(!data.result)
                        {
                            //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                            if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                            {
                                localStorage.removeItem('accessToken');
                                window.location = "/login";
                            }
                        }
                        else
                        {
                            if(!('base64data' in data.body))
                                return;

                            //Парсим данные
                            even_t.bnr_img = data.body.base64data;
                        }
                    }

                    //Сохраняем результат, если все запросы обработаны
                    if(events_processed >= events_quantity)
                    {
                        this.setState({events: events});
                        this.setState({united: {}});
                        this.get_bus();
                    }
                })
                .catch((error) => {
                    //Выключаем анимацию загрузки, если все запросы обработаны
                    if(++events_processed >= events_quantity)
                    {
                        this.setState({loading: false, need_to_init: true});
                        this.setState({united: {}});
                        this.get_bus();
                    }
                });
        }
    }

    uniqueBy = (a, cond) => {
      return a.filter((e, i) => a.findIndex(e2 => cond(e, e2)) === i);
    }

    constructLinkParams = () => {
        //Строка для возврата
        let params = "";

        //Парсим параметры адресной строки
        const query = new URLSearchParams(this.props.router.location.search);

        //Добавляем интересующие нас параметры, если они установлены
        if(query.get('empid') !== null)
            params += (params.length > 0 ? "&" : "") + "empid=" + query.get('empid')
        if(query.get('buid') !== null)
            params += (params.length > 0 ? "&" : "") + "buid=" + query.get('buid')
        if(query.get('spid') !== null)
            params += (params.length > 0 ? "&" : "") + "spid=" + query.get('spid')
        if(query.get('srvid') !== null)
            params += (params.length > 0 ? "&" : "") + "srvid=" + query.get('srvid')

        //Если есть хоть один параметр, добавляем в начало '?'
        if(params.length > 0)
            params = "?" + params;

        //Возвращаем результат
        return params;
    }

    get_bus = () => {
        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Сбрасываем ошибки
        this.setState({error_messages: []});

        //Запрашиваем подразделения
        fetch('/api/GetBusinessUnitsList', {method: 'GET', headers:{'ZR-Access-Token': UNAUTHED_TOKEN}})
            .then(response => response.json())
            .then(data => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});

                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                    return;
                }

                //В случае ошибки добавляем ее в состояние
                if(!data.result)
                {
                    //Сохраняем ошибку в списке
                    if(data.body.errorAns && this.state.error_messages.indexOf(data.body.errorAns) === -1)
                        this.setState({error_messages: [...this.state.error_messages, data.body.errorAns]});
                }
                else
                {
                    //Парсим данные
                    let business_units = {};
                    for(let bu of data.body)
                    {
                        business_units[bu.bu_id] = {};
                        business_units[bu.bu_id].bu_name = bu.bu_altname ? bu.bu_altname : bu.bu_name;
                        business_units[bu.bu_id].bu_addr = bu.bu_addr;
                    }
                    this.setState({ business_units: business_units });

                    if(Object.keys(business_units).length > 0)
                    {
                        //Включаем анимацию загрузки
                        this.setState({ loading: true });

                        //Сбрасываем ошибки
                        this.setState({error_messages: []});

                        //Запрашиваем данные по конкретным бизнес-подразделениям
                        //Временный контейнер для хранения специализаций
                        let sps_temp = [];
                        //Итоговый контейнер для хранения специализаций
                        let sps = {};
                        //Сколько специализаций обработано
                        let sps_counter = 0;
                        //Временный контейнер для хранения услуг
                        let srvs_temp = [];
                        //Итоговый контейнер для хранения услуг
                        let srvs = {};
                        //Сколько услуг обработано
                        let srvs_counter = 0;
                        //Временный контейнер для хранения докторов
                        let doctors_temp = [];
                        //Итоговый контейнер для хранения докторов
                        let doctors = {};
                        //Сколько докторов обработано
                        let doctors_counter = 0;
                        //Сколько профилей подразделений обработано
                        let bu_profiles_counter = 0;
                        for(let bu_id of Object.keys(business_units))
                        {
                            //Запрашиваем специализации
                            const request = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN },
                                body: JSON.stringify({ "buId": bu_id + "" })
                            };
                            fetch('/api/GetSpecializationsList', request)
                                .then(response => response.json())
                                .then(data => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});

                                    //Проверяем наличие обязательных полей в ответе
                                    if(!('result' in data) || !('body' in data))
                                    {
                                        //Устанавливаем ошибку и прекращаем обработку
                                        if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                            this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                                        return;
                                    }

                                    //В случае ошибки добавляем ее в состояние
                                    if(!data.result)
                                    {
                                        //Сохраняем ошибку в списке
                                        if(data.body.errorAns && this.state.error_messages.indexOf(data.body.errorAns) === -1)
                                            this.setState({error_messages: [...this.state.error_messages, data.body.errorAns]});
                                    }
                                    else
                                    {
                                        //Парсим данные
                                        sps_temp = this.uniqueBy([...sps_temp, ...data.body], (o1, o2) => o1.sp_id === o2.sp_id)
                                    }

                                    //Сохраняем список, если все запросы обработаны
                                    if(sps_counter >= Object.keys(business_units).length)
                                    {
                                        //Парсим данные из временного контейнера
                                        for(let sp of sps_temp)
                                        {
                                            sps[sp.sp_id] = {};
                                            sps[sp.sp_id].sp_name = sp.sp_name;
                                        }
                                        this.setState({ specializations: sps });

                                        //Если вообще все данные получены, вызываем функцию формирования единого объекта
                                        if(sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                            this.form_united(business_units, sps, srvs, doctors);
                                    }
                                })
                                .catch((error) => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});
                                    //Устанавливаем ошибку
                                    if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                        this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
                                });

                            //Запрашиваем услуги
                            const request2 = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN },
                                body: JSON.stringify({ "buId": bu_id + "" })
                            };
                            fetch('/api/GetServicesList', request2)
                                .then(response => response.json())
                                .then(data => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++srvs_counter >= Object.keys(business_units).length && sps_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});

                                    //Проверяем наличие обязательных полей в ответе
                                    if(!('result' in data) || !('body' in data))
                                    {
                                        //Устанавливаем ошибку и прекращаем обработку
                                        if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                            this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                                        return;
                                    }

                                    //В случае ошибки добавляем ее в состояние
                                    if(!data.result)
                                    {
                                        //Сохраняем ошибку в списке
                                        if(data.body.errorAns && this.state.error_messages.indexOf(data.body.errorAns) === -1)
                                            this.setState({error_messages: [...this.state.error_messages, data.body.errorAns]});
                                    }
                                    else
                                    {
                                        //Парсим данные
                                        srvs_temp = [...srvs_temp, ...data.body];
                                    }

                                    //Сохраняем список, если все запросы обработаны
                                    if(srvs_counter >= Object.keys(business_units).length)
                                    {
                                        //Соответствия uid`ов
                                        let bus_uids = {};
                                        let srvs_ids = {};
                                        let emp_uids = {};

                                        //Парсим данные из временного контейнера
                                        for(let srv of srvs_temp)
                                        {
                                            srvs[srv.srv_id] = srvs[srv.srv_id] ? srvs[srv.srv_id] : {};
                                            srvs[srv.srv_id].srv_name = srv.alt_name;
                                            srvs[srv.srv_id].srv_name2 = srv.srv_name;
                                            srvs[srv.srv_id].sps = srvs[srv.srv_id].sps ? srvs[srv.srv_id].sps : [];
                                            if(srvs[srv.srv_id].sps.indexOf(srv.sp_id) === -1)
                                                srvs[srv.srv_id].sps.push(srv.sp_id);
                                            srvs[srv.srv_id].emps = srvs[srv.srv_id].emps ? srvs[srv.srv_id].emps : [];
                                            if(srvs[srv.srv_id].emps.indexOf(srv.emp_id) === -1)
                                                srvs[srv.srv_id].emps.push(srv.emp_id);

                                            //Сохраняем соответствия uid`ов
                                            bus_uids[srv.bu_id] = srv.bu_uid;
                                            srvs_ids[srv.srv_uid] = srv.srv_id;
                                            emp_uids[srv.emp_id] = srv.emp_uid;
                                        }
                                        this.setState({ services: srvs, bus_uids: bus_uids, srvs_ids: srvs_ids, emp_uids: emp_uids });

                                        //Если вообще все данные получены, вызываем функцию формирования единого объекта
                                        if(sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                            this.form_united(business_units, sps, srvs, doctors);
                                    }
                                })
                                .catch((error) => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++srvs_counter >= Object.keys(business_units).length && sps_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});
                                    //Устанавливаем ошибку
                                    if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                        this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
                                });

                            //Запрашиваем врачей
                            const request3 = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN },
                                body: JSON.stringify({ "buId": bu_id + "" })
                            };
                            fetch('/api/GetDoctorsList', request3)
                                .then(response => response.json())
                                .then(data => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++doctors_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && sps_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});

                                    //Проверяем наличие обязательных полей в ответе
                                    if(!('result' in data) || !('body' in data))
                                    {
                                        //Устанавливаем ошибку и прекращаем обработку
                                        if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                            this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                                        return;
                                    }

                                    //В случае ошибки добавляем ее в состояние
                                    if(!data.result)
                                    {
                                        //Сохраняем ошибку в списке
                                        if(data.body.errorAns && this.state.error_messages.indexOf(data.body.errorAns) === -1)
                                            this.setState({error_messages: [...this.state.error_messages, data.body.errorAns]});
                                    }
                                    else
                                    {
                                        //Парсим данные
                                        doctors_temp = [...doctors_temp, ...data.body];
                                    }

                                    //Сохраняем список, если все запросы обработаны
                                    if(doctors_counter >= Object.keys(business_units).length)
                                    {
                                        //Парсим данные из временного контейнера
                                        for(let doctor of doctors_temp)
                                        {
                                            doctors[doctor.emp_id] = doctors[doctor.emp_id] ? doctors[doctor.emp_id] : {};
                                            doctors[doctor.emp_id].fio = doctor.fio;
                                            doctors[doctor.emp_id].sps = doctors[doctor.emp_id].sps ? doctors[doctor.emp_id].sps : [];
                                            if(doctors[doctor.emp_id].sps.indexOf(doctor.sp_id) === -1)
                                                doctors[doctor.emp_id].sps.push(doctor.sp_id);
                                            doctors[doctor.emp_id].bus = doctors[doctor.emp_id].bus ? doctors[doctor.emp_id].bus : [];
                                            if(doctors[doctor.emp_id].bus.indexOf(doctor.bu_id) === -1)
                                                doctors[doctor.emp_id].bus.push(doctor.bu_id);
                                        }
                                        this.setState({ doctors: doctors });

                                        //Если вообще все данные получены, вызываем функцию формирования единого объекта
                                        if(sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                            this.form_united(business_units, sps, srvs, doctors);
                                    }
                                })
                                .catch((error) => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++doctors_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && sps_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});
                                    //Устанавливаем ошибку
                                    if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                        this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
                                });

                            //Запрашиваем профили подразделений
                            const request4 = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN },
                                body: JSON.stringify({ "buId": bu_id + "" })
                            };
                            fetch('/api/GetBuInfo', request4)
                                .then(response => response.json())
                                .then(data => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++bu_profiles_counter >= Object.keys(business_units).length && sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});

                                    //Проверяем наличие обязательных полей в ответе
                                    if(!('result' in data) || !('body' in data))
                                    {
                                        //Устанавливаем ошибку и прекращаем обработку
                                        if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                            this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                                        return;
                                    }

                                    //В случае ошибки добавляем ее в состояние
                                    if(!data.result)
                                    {
                                        //Сохраняем ошибку в списке
                                        if(data.body.errorAns && this.state.error_messages.indexOf(data.body.errorAns) === -1)
                                            this.setState({error_messages: [...this.state.error_messages, data.body.errorAns]});
                                    }
                                    else
                                    {
                                        //Парсим данные
                                        if(data.body.TEL)
                                            business_units[bu_id].tel = data.body.TEL;
                                    }

                                    //Сохраняем список, если все запросы обработаны
                                    if(bu_profiles_counter >= Object.keys(business_units).length)
                                    {
                                        this.setState({ business_units: business_units });

                                        //Если вообще все данные получены, вызываем функцию формирования единого объекта
                                        if(sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length && bu_profiles_counter >= Object.keys(business_units).length)
                                            this.form_united(business_units, sps, srvs, doctors);
                                    }
                                })
                                .catch((error) => {
                                    //Выключаем анимацию загрузки, если все запросы обработаны
                                    if(++bu_profiles_counter >= Object.keys(business_units).length && sps_counter >= Object.keys(business_units).length && srvs_counter >= Object.keys(business_units).length && doctors_counter >= Object.keys(business_units).length)
                                        this.setState({loading: false});
                                    //Устанавливаем ошибку
                                    if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                        this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
                                });
                        }
                    }
                }
            })
            .catch((error) => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
            });
    }

    fill_list = (bus_lst, sps_lst, srvs_lst, united, search_applied, selected_business_unit_id, selected_specialization_id) => {
        for(let entry of Object.entries(united).filter((entry) => !search_applied.length || entry[1].fio.toLowerCase().includes(search_applied.toLowerCase())))
        {
            for(let bu of Object.entries(entry[1].bus))
            {
                if(bu[1] == undefined || Object.entries(bu[1]).length == 0)
                    continue;

                if(bus_lst.indexOf(bu[0]) == -1)
                    bus_lst.push(bu[0]);
            }
        }

        for(let entry of Object.entries(united).filter((entry) => selected_business_unit_id == 0 || entry[1].bus[selected_business_unit_id] != undefined)
                        .filter((entry) => !search_applied.length || entry[1].fio.toLowerCase().includes(search_applied.toLowerCase())))
        {
            for(let sp of Object.entries(entry[1].sps))
            {
                if(sp[1] == undefined || Object.entries(sp[1]).length == 0)
                    continue;

                if(sps_lst.indexOf(sp[0]) == -1)
                    sps_lst.push(sp[0]);
            }
        }

        for(let entry of Object.entries(united).filter((entry) => selected_business_unit_id == 0 || entry[1].bus[selected_business_unit_id] != undefined)
                        .filter((entry) => selected_specialization_id == 0 || Object.keys(entry[1].sps).includes(selected_specialization_id + ""))
                        .filter((entry) => !search_applied.length || entry[1].fio.toLowerCase().includes(search_applied.toLowerCase())))
        {
            for(let srv of Object.entries(entry[1].srvs))
            {
                if(srvs_lst.indexOf(srv[0]) == -1)
                    srvs_lst.push(srv[0]);
            }
        }
    }

    form_united = (bus, sps, srvs, doctors) => {
        //Формируем список united из имеющихся данных
        let united = this.state.united;
        for(let doctor of Object.entries(doctors))
        {
            if(doctor[1] === undefined)
                continue;

            //Если для этого врача уже загружено расписание, пропускаем
            if(united[doctor[0]] !== undefined && united[doctor[0]].loaded)
                continue;

            let item = {};
            item = {};
            item.fio = doctor[1].fio;

            item.sps = item.sps ? item.sps : {};
            for(let sp of doctor[1].sps)
            {
                if(sps[sp] === undefined)
                    continue;

                item.sps = item.sps ? item.sps : {};
                item.sps[sp] = item.sps[sp] ? item.sps[sp] : {};
                item.sps[sp].sp_name = sps[sp].sp_name;
            }

            item.bus = item.bus ? item.bus : {};
            for(let bu of doctor[1].bus)
            {
                if(bus[bu] === undefined)
                    continue;

                item.bus = item.bus ? item.bus : {};
                item.bus[bu] = item.bus[bu] ? item.bus[bu] : {};
                item.bus[bu].bu_addr = bus[bu].bu_addr;
                item.bus[bu].bu_name = bus[bu].bu_name;
            }

            item.srvs = item.srvs ? item.srvs : {};
            for(let srv of Object.keys(srvs))
            {
                if(srvs[srv].sps.length === 0)
                    continue;

                if(srvs[srv].emps.indexOf(doctor[0]) === -1)
                    continue;

                item.srvs = item.srvs ? item.srvs : {};
                item.srvs[srv] = item.srvs[srv] ? item.srvs[srv] : {};
                item.srvs[srv].srv_name = srvs[srv].srv_name;
                item.srvs[srv].srv_name2 = srvs[srv].srv_name2;
                item.srvs[srv].sp_id = srvs[srv].sps[0];
            }

            item.selected_bu = Object.keys(item.bus).length ? Object.keys(item.bus)[0] : 0;
            item.selected_date = 0;
            item.selected_time = -1;
            item.schedule = {};
            item.loaded = false;
            item.loading = false;
            item.profile = {};
            item.avatar = "";

            united[doctor[0]] = item;
        }

        let bus_lst = [];
        let sps_lst = [];
        let srvs_lst = [];
        this.fill_list(bus_lst, sps_lst, srvs_lst, united, this.state.search_applied, this.state.selected_business_unit_id, this.state.selected_specialization_id);

        //Парсим параметры адресной строки
        const query = new URLSearchParams(this.props.router.location.search);

        if(query.get('empid') !== null)
        {
            if(Object.keys(united).indexOf(query.get('empid')) != -1)
                this.setState({search: united[query.get('empid')].fio, search_applied: united[query.get('empid')].fio});
        }
        this.fill_list(bus_lst, sps_lst, srvs_lst, united, this.state.search_applied, this.state.selected_business_unit_id, this.state.selected_specialization_id);


        //Если buid указан и есть среди бизнес-подразделений, устанавливаем фильтр
        if(query.get('buid') !== null)
            if(Object.keys(this.state.business_units).filter((unit) => bus_lst.includes(unit)).indexOf(query.get('buid')) != -1)
                this.setState({selected_business_unit_id: Number(query.get('buid'))});
        this.fill_list(bus_lst, sps_lst, srvs_lst, united, this.state.search_applied, this.state.selected_business_unit_id, this.state.selected_specialization_id);

        //Если spid указан и есть среди специализаций, устанавливаем фильтр
        if(query.get('spid') !== null)
            if(Object.keys(this.state.specializations).filter((sp) => sps_lst.includes(sp)).indexOf(query.get('spid')) != -1)
                this.setState({selected_specialization_id: Number(query.get('spid'))});
        this.fill_list(bus_lst, sps_lst, srvs_lst, united, this.state.search_applied, this.state.selected_business_unit_id, this.state.selected_specialization_id);

        //Если srvid указан и есть среди услуг, устанавливаем фильтр
        if(query.get('srvid') !== null)
            if(Object.keys(this.state.services).filter((srv) => srvs_lst.includes(srv)).indexOf(query.get('srvid')) != -1)
                this.setState({selected_service_id: Number(query.get('srvid'))});

        this.setState({united: united, current_page: 1, need_to_init: true});
    }

    handleScroll = (e) => {
        const elements = document.querySelectorAll('.appointment-list--item');

        for (const element of elements) {
            if(!this.state.united[element.dataset.key].loaded && !this.state.united[element.dataset.key].loading && this.isVisible(element))
            {
                //Помечаем факт начала загрузки данных элемента
                {
                    let united = this.state.united;
                    united[element.dataset.key].loading = true;
                    this.setState({united: united});
                }

                //Сбрасываем ошибки
                this.setState({error_messages: []});

                //Сколько записей обработано
                let bus_counter = 0;
                let sps_counter = {};
                for(let bu of Object.keys(this.state.united[element.dataset.key].bus))
                {
                    //Сколько специальностей обработано
                    sps_counter[bu] = 0;
                    for(let sp of Object.keys(this.state.united[element.dataset.key].sps))
                    {
                        /* eslint-disable */
                        fetch('/api/GetDoctorSchedule', {method: 'POST', headers:{'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN},
                            body: JSON.stringify({ "buId": bu, "spId": sp, "empId": element.dataset.key })})
                            .then(response => response.json())
                            .then(data => {
                                ++sps_counter[bu];

                                //Проверяем наличие обязательных полей в ответе
                                if(!('result' in data) || !('body' in data))
                                {
                                    //Устанавливаем ошибку и прекращаем обработку
                                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                        this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                                }
                                else
                                {
                                    //В случае ошибки добавляем ее в состояние
                                    if(!data.result)
                                    {
                                        //Сохраняем ошибку в списке
                                        if(data.body.errorAns && this.state.error_messages.indexOf(data.body.errorAns) === -1)
                                            if(data.body.errorAns !== "Расписание врача не обнаружено.")
                                                this.setState({error_messages: [...this.state.error_messages, data.body.errorAns]});
                                    }
                                    else
                                    {
                                        //Парсим данные
                                        let united = this.state.united;
                                        united[element.dataset.key].schedule = united[element.dataset.key].schedule ? united[element.dataset.key].schedule : {};
                                        united[element.dataset.key].schedule[bu] = united[element.dataset.key].schedule[bu] ? united[element.dataset.key].schedule[bu] : {};
                                        united[element.dataset.key].schedule[bu][sp] = data.body;
                                        united[element.dataset.key].selected_bu = united[element.dataset.key].selected_bu ? united[element.dataset.key].selected_bu : Object.keys(united[element.dataset.key].schedule)[0];
                                    }
                                }

                                if(sps_counter[bu] >= Object.keys(this.state.united[element.dataset.key].sps).length)
                                    if(++bus_counter >= Object.keys(this.state.united[element.dataset.key].bus).length)
                                        {
                                        }

                                //Выключаем анимацию загрузки и сохраням результат, если все запросы обработаны
                                if(sps_counter[bu] >= Object.keys(this.state.united[element.dataset.key].sps).length && bus_counter >= Object.keys(this.state.united[element.dataset.key].bus).length)
                                {
                                    //Помечаем факт загрузки данных
                                    let united = this.state.united;
                                    united[element.dataset.key].loaded = true;
                                    united[element.dataset.key].loading = false;
                                    this.setState({united: united, need_to_init: true});
                                }
                            })
                            .catch((error) => {
                                if(sps_counter[bu] >= Object.keys(this.state.united[element.dataset.key].sps).length)
                                    if(++bus_counter >= Object.keys(this.state.united[element.dataset.key].bus).length)
                                    {
                                    }

                                //Выключаем анимацию загрузки и сохраням результат, если все запросы обработаны
                                if(sps_counter[bu] >= Object.keys(this.state.united[element.dataset.key].sps).length && bus_counter >= Object.keys(this.state.united[element.dataset.key].bus).length)
                                {
                                    //Помечаем факт загрузки данных
                                    let united = this.state.united;
                                    united[element.dataset.key].loaded = true;
                                    united[element.dataset.key].loading = false;
                                    this.setState({united: united, need_to_init: true});
                                }
                                //Устанавливаем ошибку
                                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                    this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
                            });
                        /* eslint-enable */
                    }
                }

                fetch('/api/GetEmpProfile', {method: 'POST', headers:{'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN},
                    body: JSON.stringify({ "empId": element.dataset.key })})
                    .then(response => response.json())
                    .then(data => {
                        //Проверяем наличие обязательных полей в ответе
                        if(!('result' in data) || !('body' in data))
                        {
                            //Устанавливаем ошибку и прекращаем обработку
                            if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                        }
                        else
                        {
                            //В случае ошибки добавляем ее в состояние
                            if(!data.result)
                            {
                                //Сохраняем ошибку в списке
                                if(data.body.errorAns && this.state.error_messages.indexOf(data.body.errorAns) === -1)
                                    this.setState({error_messages: [...this.state.error_messages, data.body.errorAns]});
                            }
                            else
                            {
                                //Парсим данные
                                let united = this.state.united;
                                united[element.dataset.key].profile = data.body;
                                this.setState({united: united, need_to_init: true});

                                //Запрашиваем аватар
                                fetch('/api/GetImageById', {method: 'POST', headers:{'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN},
                                    body: JSON.stringify({ "imgId": united[element.dataset.key].profile.PICTURE })})
                                    .then(response => response.json())
                                    .then(data => {
                                        //Проверяем наличие обязательных полей в ответе
                                        if(!('result' in data) || !('body' in data))
                                            return;
                                        else
                                        {
                                            if(data.result)
                                            {
                                                if(!('base64data' in data.body))
                                                    return;

                                                //Парсим данные
                                                let united = this.state.united;
                                                united[element.dataset.key].avatar = data.body.base64data;
                                                this.setState({united: united, need_to_init: true});
                                            }
                                        }
                                    })
                                    .catch((error) => {

                                    });
                            }
                        }
                    })
                    .catch((error) => {
                        //Устанавливаем ошибку
                        if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                            this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
                    });
            }
        }
    }

    getDayName = (year, day, month) => {
        let date = new Date(year, month - 1, day);
        return date.toLocaleDateString('ru-RU', {weekday: 'short'});
    }

    isVisible = (el) => {
        const rect = el.getBoundingClientRect();
        const vWidth = window.innerWidth || document.documentElement.clientWidth;
        const vHeight = window.innerHeight || document.documentElement.clientHeight;
        const efp = function (x, y) { return document.elementFromPoint(x, y); };
        // Return false if it's not in the viewport
        if (rect.right < 0 || rect.bottom < 0
            || rect.left > vWidth || rect.top > vHeight) { return false; }
        // Return true if any of its four corners are visible
        return (
            el.contains(efp(rect.left, rect.top))
            || el.contains(efp(rect.right, rect.top))
            || el.contains(efp(rect.right, rect.bottom))
            || el.contains(efp(rect.left, rect.bottom))
        );
    };

    changeDateFormat = (date) => {
        if(date.length < 10)
            return date;
        let new_date = date[8] + date[9] + '.' + date[5] + date[6] + '.' + date[0] + date[1] + date[2] + date[3] + date.substring(10, date.length);
        return new_date;
    }

    trimFilterDescr = (descr) => {
        if(descr.length > 40)
            return descr.substring(0, 40) + "...";
        else
            return descr;
    }

    adjast_page_size = (entries, pages) => {
        //Если страниц немного, возвращаем дефолтное количество записей
        if(pages <= 11)
        {
            page_size = page_size_default;
            pages = Math.ceil(entries.length / page_size);
        }

        //Пока страниц много, увеличиваем количество записей
        while(pages > 11)
        {
            page_size += 5;
            pages = Math.ceil(entries.length / page_size);
        }
    }

    render() {
        schedule = {};
        {
            for(let doctor of Object.entries(this.state.united).filter((entry) => this.state.selected_business_unit_id == 0 || entry[1].schedule[this.state.selected_business_unit_id] != undefined)
                            .filter((entry) => this.state.selected_specialization_id == 0 || Object.keys(entry[1].sps).includes(this.state.selected_specialization_id + ""))
                            .filter((entry) => this.state.selected_service_id == 0 || Object.keys(entry[1].srvs).includes(this.state.selected_service_id + ""))
                            .filter((entry) => !this.state.search_applied.length || entry[1].fio.toLowerCase().includes(this.state.search_applied.toLowerCase())))
            {
                if(this.state.united[doctor[0]].selected_bu == 0)
                    continue;

                if(this.state.united[doctor[0]].schedule[this.state.united[doctor[0]].selected_bu] != undefined)
                    for(let sp_dates of Object.entries(this.state.united[doctor[0]].schedule[this.state.united[doctor[0]].selected_bu]))
                    {
                        if(this.state.selected_specialization_id != 0 && sp_dates[0] != this.state.selected_specialization_id)
                            continue;

                        for(let date of Object.entries(sp_dates[1]))
                        {
                            for(let time of Object.entries(date[1]))
                            {
                                schedule[doctor[0]] = schedule[doctor[0]] ? schedule[doctor[0]] : {};
                                schedule[doctor[0]][date[0]] = schedule[doctor[0]][date[0]] ? schedule[doctor[0]][date[0]] : {};
                                schedule[doctor[0]][date[0]][time[0]] = time[1];
                            }
                        }
                    }
            }
        }

        let bus = [];
        let sps = [];
        let srvs = [];
        this.fill_list(bus, sps, srvs, this.state.united, this.state.search_applied, this.state.selected_business_unit_id, this.state.selected_specialization_id);

        //Получаем список записей для отображения в первой секции
        let entries = Object.entries(this.state.united).sort((a, b) => a[1].fio.localeCompare(b[1].fio))
                            .filter((entry) => this.state.selected_business_unit_id == 0 || entry[1].bus[this.state.selected_business_unit_id] != undefined)
                            .filter((entry) => this.state.selected_specialization_id == 0 || Object.keys(entry[1].sps).includes(this.state.selected_specialization_id + ""))
                            .filter((entry) => this.state.selected_service_id == 0 || Object.keys(entry[1].srvs).includes(this.state.selected_service_id + ""))
                            .filter((entry) => this.state.selected_date == "" || (schedule[entry[0]] != undefined && Object.keys(schedule[entry[0]]).includes(this.state.selected_date)))
                            .filter((entry) => !this.state.search_applied.length || entry[1].fio.toLowerCase().includes(this.state.search_applied.toLowerCase()));

        //Получаем количество страниц и подгоняем количество элементов
        let pages = Math.ceil(entries.length / page_size);
        this.adjast_page_size(entries, pages);

        return (
            <>
                {this.state.loading &&
                <div class="pre-loader">
                    <div class="loader-spinner">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                }

                <div class="container" style={{"height": "10.9rem"}}>
                    <UnloggedHeader link="/" />
                </div>
                <main>
                    <div class="content">
                        <div class="container flex">
                            <div class="side-bar" style={{"visibility": "hidden"}}>
                                <ul class="side-bar--menu">
                                    <li class={this.props.router.location.pathname === "/" ? "selected" : ""}><Link to={"/"}>Главная</Link></li>
                                    <li class={this.props.router.location.pathname === "/tests" ? "selected" : ""}><Link to={"/tests"}>Мои анализы</Link></li>
                                    <li class={this.props.router.location.pathname === "/visits" ? "selected" : ""}><Link to={"/visits"}>Моя история</Link></li>
                                    <li class={this.props.router.location.pathname === "/profile" ? "selected" : ""}><Link to={"/profile"}>Профиль</Link></li>
                                    <li class={this.props.router.location.pathname === "/promotions" ? "selected" : ""}><Link to={"/promotions"}>Специальные предложения</Link></li>
                                    <li class={this.props.router.location.pathname === "/contacts" ? "selected" : ""}><Link to={"/contacts"}>Контакты</Link></li>
                                    <li class={this.props.router.location.pathname === "/doctors" ? "selected" : ""}><Link to={"/doctors"}>Врачи</Link></li>
                                </ul>
                                <div class="side-bar--social">
                                    <p class="side-bar--social__title">
                                        Следите за нами в соцсетях
                                    </p>
                                    <div class="side-bar--social__list">
                                        <a href="https://vk.com/mczr_med" target="_blank">
                                            <img src={vk_logo}></img>
                                        </a>
                                        <a href="https://t.me/zr_medical" target="_blank">
                                            <img src={tg_logo}></img>
                                        </a>
                                    </div>
                                </div>
                                <a href="https://t.me/ZR_info_bot" target="_blank" class="button-telegram">Чат-бот Telegram</a>
                            </div>
                            <div class="side-content">
                                {this.state.events.length !== 0 &&
                                <div class="articles">
                                    <p class="block-title">
                                        ДЛЯ ВАС
                                    </p>
                                    <div class="swiper">
                                        <div class="swiper-wrapper">
                                            {this.state.events.map((data, index) =>
                                                <div class="swiper-slide" key={index}>
                                                    <a href={data.bnr_href} class="articles--item" target="_blank">
                                                        <img style={{backgroundImage: `url(data:image/jpeg;base64,${data.bnr_img})`}} class="articles--item__image"></img>
                                                        <p class="articles--item__title">
                                                            {data.bnr_name}
                                                        </p>
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="navigation-item navigation-prev">
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.5" cy="11.5" r="11.5" transform="rotate(-180 11.5 11.5)" fill="#7E7E7E"/>
                                            <path d="M14.7158 5.63439C14.3416 5.26016 13.7348 5.26016 13.3606 5.63439L8.6768 10.3228C7.92892 11.0714 7.92921 12.2845 8.67738 13.0327L13.364 17.7193C13.7382 18.0936 14.3451 18.0936 14.7193 17.7193C15.0936 17.3451 15.0936 16.7383 14.7193 16.364L10.7081 12.3528C10.3338 11.9786 10.3338 11.3717 10.7081 10.9975L14.7158 6.98966C15.0901 6.61543 15.0901 6.00871 14.7158 5.63439Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <div class="navigation-item navigation-next">
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.5" cy="11.5" r="11.5" fill="#7E7E7E"/>
                                            <path d="M8.28415 17.3656C8.65839 17.7398 9.26521 17.7398 9.63944 17.3656L14.3232 12.6772C15.0711 11.9286 15.0708 10.7155 14.3226 9.96728L9.63599 5.28069C9.26176 4.90644 8.65494 4.90644 8.28069 5.28069C7.90644 5.65494 7.90644 6.26172 8.28069 6.63598L12.2919 10.6472C12.6662 11.0214 12.6662 11.6283 12.2919 12.0025L8.28415 16.0103C7.90989 16.3846 7.90989 16.9913 8.28415 17.3656Z" fill="white"/>
                                        </svg>
                                    </div>
                                </div>}
                                <h1>
                                    Записаться на приём
                                </h1>
                                <div class="search-line">
                                    <form action="" class="search-line--inner">
                                        <label class="search-line--field">
                                            <span class="search-line--field__title">Поиск</span>
                                            <input class="search-line--field__input" type="text" name="search" placeholder="Введите фамилию врача" value={this.state.search} onChange={(e) => { this.setState({ search: e.target.value }); if(e.target.value === "") this.setState({ search_applied: "", current_page: 1, need_to_init: true }); }}></input>
                                            {this.state.search.length > 0 && <div class="search-cancel"><Icon icon={x} onClick={(e) => {this.setState({selected_business_unit_id: 0, current_page: 1, selected_date: "", selected_specialization_id: 0, selected_service_id: 0, selected_date: "", search: "", search_applied: "", need_to_init: true}); this.resetSelections(Number(e.target.value));} }/></div>}
                                        </label>
                                        <button class="button-primary" onClick={(e) => { e.preventDefault(); this.setState({ selected_business_unit_id: 0, current_page: 1, selected_date: "", selected_specialization_id: 0, selected_service_id: 0, selected_date: "", search_applied: this.state.search, need_to_init: true }); this.resetSelections(Number(e.target.value));}}>Найти</button>
                                    </form>
                                </div>
                                <div class="appointment-list">
                                <div class="filter">
                                    <div class="filter--inner">
                                        <form action="">
                                            <span class="filter--close">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.16699 22.8327L22.6159 1.38377M1.16699 1.16602L22.6159 22.6149" stroke="#D30D15" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                            <p class="filter--title">
                                                ФИЛЬТР
                                            </p>
                                            <div class={this.state.selected_business_unit_id !== 0 ? "filter--item with-dropdown filled" : "filter--item with-dropdown"} id="with-dropdown-business">
                                                <span class="icon">
                                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.6667 6.7691V12.6559C15.6667 14.1959 15.6667 14.966 15.3669 15.5543C15.1033 16.0717 14.6826 16.4925 14.1652 16.7561C13.5769 17.0559 12.8068 17.0559 11.2667 17.0559H7.23333C5.69319 17.0559 4.92311 17.0559 4.33486 16.7561C3.81741 16.4925 3.39672 16.0717 3.13307 15.5543C2.83333 14.966 2.83333 14.1959 2.83333 12.6559V6.7685M17.5 8.80586L12.5196 3.27281C11.3868 2.01445 10.8205 1.38526 10.1535 1.15298C9.56772 0.948961 8.93008 0.949007 8.34424 1.15311C7.67727 1.3855 7.11106 2.01476 5.97855 3.2733L1 8.80586M9.25 8.80586V12.4725M11.0833 10.6392H7.41667" stroke="#D30D15" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </span>
                                                {this.state.selected_business_unit_id === 0 ? 'Филиал' : this.trimFilterDescr(this.state.business_units[this.state.selected_business_unit_id].bu_name)}
                                                <div class="with-dropdown--menu">
                                                    <div class="with-dropdown--menu__inner">
                                                        <div class="scroll">
                                                        <label class="with-dropdown--menu__item filter-search-container">
                                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" class="search-icon" viewBox="0,0,256,256" width="15px" height="15px" fillRule="nonzero"><g fill="#d30d15" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{'mixBlendMode': 'normal'}}><g transform="scale(5.12,5.12)"><path d="M21,3c-9.37891,0 -17,7.62109 -17,17c0,9.37891 7.62109,17 17,17c3.71094,0 7.14063,-1.19531 9.9375,-3.21875l13.15625,13.125l2.8125,-2.8125l-13,-13.03125c2.55469,-2.97656 4.09375,-6.83984 4.09375,-11.0625c0,-9.37891 -7.62109,-17 -17,-17zM21,5c8.29688,0 15,6.70313 15,15c0,8.29688 -6.70312,15 -15,15c-8.29687,0 -15,-6.70312 -15,-15c0,-8.29687 6.70313,-15 15,-15z"></path></g></g></svg>
                                                            <input class="filter-search" type="text" autocomplete="off" value={this.state.business_unit_filter_search} onChange={(e) => this.setState({ business_unit_filter_search: e.target.value }) }></input>
                                                        </label>
                                                            <label class="with-dropdown--menu__item">
                                                                <input class="hidden-input" type="checkbox" value="0" checked={this.state.selected_business_unit_id == 0} onChange={(e) => { this.setState({ selected_business_unit_id: Number("0"), current_page: 1, selected_specialization_id: 0, selected_service_id: 0, selected_date: "", need_to_init: true }); this.resetSelections();}}></input>
                                                                <span>Филиал</span>
                                                            </label>
                                                            {Object.entries(this.state.business_units).filter((unit) => bus.includes(unit[0])).filter((unit) => this.state.business_unit_filter_search === "" ? true : unit[1].bu_name.toLowerCase().includes(this.state.business_unit_filter_search.toLowerCase())).sort((a, b) => a[1].bu_name.localeCompare(b[1].bu_name)).map((unit) =>
                                                            <label class="with-dropdown--menu__item" key={unit[0]}>
                                                                <input class="hidden-input" type="checkbox" value={unit[0]} checked={this.state.selected_business_unit_id == unit[0]} onChange={(e) => { this.setState({ selected_business_unit_id: Number(e.target.value), current_page: 1, selected_date: "", selected_specialization_id: 0, selected_service_id: 0, selected_date: "", need_to_init: true }); this.resetSelections(Number(e.target.value));}}></input>
                                                                <span>{unit[1].bu_name}</span>
                                                            </label>)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class={this.state.selected_specialization_id !== 0 ? "filter--item with-dropdown filled" : "filter--item with-dropdown"} id="with-dropdown-specialization">
                                                <span class="icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M17.7596 12.7703V15.3547C17.7596 16.6369 17.2502 17.8667 16.3435 18.7733C15.4368 19.68 14.2071 20.1894 12.9248 20.1894C11.6426 20.1894 10.4129 19.68 9.50617 18.7733C8.59948 17.8667 8.09011 16.6369 8.09011 15.3547V14.7863C7.01583 14.6188 6.03673 14.073 5.32939 13.2473C4.62204 12.4216 4.233 11.3703 4.23242 10.2831V6.6313C4.23258 6.2781 4.32079 5.93051 4.48907 5.61998C4.65735 5.30944 4.90039 5.04576 5.19621 4.85278C5.21724 4.51399 5.35072 4.19191 5.5755 3.93757C5.80028 3.68323 6.10351 3.51117 6.43714 3.44866C6.77078 3.38615 7.11573 3.43676 7.41734 3.59248C7.71895 3.7482 7.95997 4.00011 8.10222 4.30831C8.24446 4.6165 8.27979 4.96335 8.20261 5.2939C8.12542 5.62444 7.94014 5.91978 7.67612 6.13311C7.4121 6.34644 7.08444 6.46556 6.74505 6.47161C6.40567 6.47765 6.07398 6.37026 5.80253 6.16646C5.69262 6.29643 5.63221 6.46109 5.632 6.6313V10.2818C5.632 11.1194 5.96471 11.9226 6.55693 12.5148C7.14915 13.107 7.95237 13.4397 8.7899 13.4397C9.62742 13.4397 10.4306 13.107 11.0229 12.5148C11.6151 11.9226 11.9478 11.1194 11.9478 10.2818V6.6313C11.9478 6.47982 11.9001 6.33219 11.8114 6.20941C11.5298 6.39911 11.1929 6.48946 10.8542 6.46616C10.5154 6.44286 10.1941 6.30723 9.94112 6.08076C9.68813 5.85428 9.51791 5.54989 9.4574 5.21577C9.39689 4.88165 9.44956 4.5369 9.60706 4.23609C9.76456 3.93527 10.0179 3.69558 10.327 3.55497C10.636 3.41435 10.9832 3.38084 11.3134 3.45973C11.6437 3.53863 11.9382 3.72543 12.1503 3.99055C12.3625 4.25568 12.4801 4.58399 12.4846 4.92352C12.752 5.12081 12.9694 5.37811 13.1193 5.67473C13.2691 5.97134 13.3472 6.29899 13.3474 6.6313V10.2818C13.3468 11.3691 12.9577 12.4203 12.2504 13.246C11.5431 14.0717 10.564 14.6175 9.48969 14.785V15.3534C9.48969 16.2643 9.85154 17.1379 10.4956 17.782C11.1397 18.4261 12.0133 18.7879 12.9242 18.7879C13.8351 18.7879 14.7087 18.4261 15.3528 17.782C15.9969 17.1379 16.3587 16.2643 16.3587 15.3534V12.7703C15.7239 12.6005 15.1725 12.2056 14.8072 11.6594C14.442 11.1131 14.2878 10.4526 14.3734 9.80111C14.459 9.14958 14.7786 8.5514 15.2727 8.11807C15.7667 7.68474 16.4014 7.4458 17.0585 7.4458C17.7157 7.4458 18.3504 7.68474 18.8444 8.11807C19.3384 8.5514 19.658 9.14958 19.7436 9.80111C19.8293 10.4526 19.6751 11.1131 19.3098 11.6594C18.9446 12.2056 18.3931 12.6005 17.7583 12.7703H17.7596ZM18.3659 10.1555C18.3659 9.89694 18.2892 9.64418 18.1456 9.42918C18.0019 9.21418 17.7977 9.04662 17.5588 8.94766C17.3199 8.84871 17.0571 8.82282 16.8035 8.87327C16.5499 8.92371 16.3169 9.04823 16.1341 9.23107C15.9512 9.4139 15.8267 9.64686 15.7763 9.90046C15.7258 10.1541 15.7517 10.4169 15.8507 10.6558C15.9496 10.8947 16.1172 11.0989 16.3322 11.2426C16.5472 11.3862 16.8 11.4629 17.0585 11.4629C17.4053 11.4625 17.7377 11.3247 17.9831 11.0797C18.2284 10.8346 18.3665 10.5023 18.3672 10.1555H18.3659Z" fill="#D30D15"/>
                                                    </svg>
                                                </span>
                                                {this.state.selected_specialization_id === 0 ? 'Специальность' : this.trimFilterDescr(this.state.specializations[this.state.selected_specialization_id].sp_name)}
                                                <div class="with-dropdown--menu">
                                                    <div class="with-dropdown--menu__inner">
                                                        <div class="scroll">
                                                            <label class="with-dropdown--menu__item filter-search-container">
                                                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" class="search-icon" viewBox="0,0,256,256" width="15px" height="15px" fillRule="nonzero"><g fill="#d30d15" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{'mixBlendMode': 'normal'}}><g transform="scale(5.12,5.12)"><path d="M21,3c-9.37891,0 -17,7.62109 -17,17c0,9.37891 7.62109,17 17,17c3.71094,0 7.14063,-1.19531 9.9375,-3.21875l13.15625,13.125l2.8125,-2.8125l-13,-13.03125c2.55469,-2.97656 4.09375,-6.83984 4.09375,-11.0625c0,-9.37891 -7.62109,-17 -17,-17zM21,5c8.29688,0 15,6.70313 15,15c0,8.29688 -6.70312,15 -15,15c-8.29687,0 -15,-6.70312 -15,-15c0,-8.29687 6.70313,-15 15,-15z"></path></g></g></svg>
                                                                <input class="filter-search" type="text" autocomplete="off" value={this.state.specialization_filter_search} onChange={(e) => this.setState({ specialization_filter_search: e.target.value }) }></input>
                                                            </label>
                                                            <label class="with-dropdown--menu__item">
                                                                <input class="hidden-input" type="checkbox" value="0" checked={this.state.selected_specialization_id == 0} onChange={(e) => { this.setState({ selected_specialization_id: Number("0"), current_page: 1, selected_service_id: 0, selected_date: "", need_to_init: true }); this.resetSelections(this.state.selected_business_unit_id != 0 ? this.state.selected_business_unit_id : null); }}></input>
                                                                <span>Специальность</span>
                                                            </label>
                                                            {Object.entries(this.state.specializations).filter((sp) => sps.includes(sp[0])).filter((sp) => this.state.specialization_filter_search === "" ? true : sp[1].sp_name.toLowerCase().includes(this.state.specialization_filter_search.toLowerCase())).sort((a, b) => a[1].sp_name.localeCompare(b[1].sp_name)).map((sp) =>
                                                            <label class="with-dropdown--menu__item" key={sp[0]}>
                                                                <input class="hidden-input" type="checkbox" value={sp[0]} checked={this.state.selected_specialization_id == sp[0]} onChange={(e) => { this.setState({ selected_specialization_id: Number(e.target.value), current_page: 1, selected_service_id: 0, selected_date: "", need_to_init: true }); this.resetSelections(this.state.selected_business_unit_id != 0 ? this.state.selected_business_unit_id : null); }}></input>
                                                                <span>{sp[1].sp_name}</span>
                                                            </label>)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class={this.state.selected_service_id !== 0 ? "filter--item with-dropdown filled" : "filter--item with-dropdown"} id="with-dropdown-service">
                                                <span class="icon">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8.33301 1.66602H11.6663C12.3294 1.66602 12.9653 1.92941 13.4341 2.39825C13.9029 2.86709 14.1663 3.50297 14.1663 4.16602V4.99935H15.833C16.496 4.99935 17.1319 5.26274 17.6008 5.73158C18.0696 6.20042 18.333 6.83631 18.333 7.49935V15.8327C18.333 16.4957 18.0696 17.1316 17.6008 17.6004C17.1319 18.0693 16.496 18.3327 15.833 18.3327H4.16634C3.5033 18.3327 2.86742 18.0693 2.39858 17.6004C1.92974 17.1316 1.66634 16.4957 1.66634 15.8327V7.49935C1.66634 6.83631 1.92974 6.20042 2.39858 5.73158C2.86742 5.26274 3.5033 4.99935 4.16634 4.99935H5.83301V4.16602C5.83301 3.50297 6.0964 2.86709 6.56524 2.39825C7.03408 1.92941 7.66997 1.66602 8.33301 1.66602ZM12.4997 4.16602C12.4997 3.945 12.4119 3.73304 12.2556 3.57676C12.0993 3.42048 11.8874 3.33268 11.6663 3.33268H8.33301C8.112 3.33268 7.90003 3.42048 7.74375 3.57676C7.58747 3.73304 7.49968 3.945 7.49968 4.16602V4.99935H12.4997V4.16602ZM3.33301 7.49935V15.8327C3.33301 16.0537 3.42081 16.2657 3.57709 16.4219C3.73337 16.5782 3.94533 16.666 4.16634 16.666H15.833C16.054 16.666 16.266 16.5782 16.4223 16.4219C16.5785 16.2657 16.6663 16.0537 16.6663 15.8327V7.49935C16.6663 7.27833 16.5785 7.06637 16.4223 6.91009C16.266 6.75381 16.054 6.66601 15.833 6.66601H4.16634C3.94533 6.66601 3.73337 6.75381 3.57709 6.91009C3.42081 7.06637 3.33301 7.27833 3.33301 7.49935ZM9.16634 10.8327H7.49968V12.4993H9.16634V14.166H10.833V12.4993H12.4997V10.8327H10.833V9.16601H9.16634V10.8327Z" fill="#D30D15"/>
                                                    </svg>
                                                </span>
                                                {this.state.selected_service_id === 0 ? 'Услуга' : this.trimFilterDescr(this.state.services[this.state.selected_service_id].srv_name)}
                                                <div class="with-dropdown--menu">
                                                    <div class="with-dropdown--menu__inner">
                                                        <div class="scroll">
                                                            <label class="with-dropdown--menu__item filter-search-container">
                                                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" class="search-icon" viewBox="0,0,256,256" width="15px" height="15px" fillRule="nonzero"><g fill="#d30d15" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{'mixBlendMode': 'normal'}}><g transform="scale(5.12,5.12)"><path d="M21,3c-9.37891,0 -17,7.62109 -17,17c0,9.37891 7.62109,17 17,17c3.71094,0 7.14063,-1.19531 9.9375,-3.21875l13.15625,13.125l2.8125,-2.8125l-13,-13.03125c2.55469,-2.97656 4.09375,-6.83984 4.09375,-11.0625c0,-9.37891 -7.62109,-17 -17,-17zM21,5c8.29688,0 15,6.70313 15,15c0,8.29688 -6.70312,15 -15,15c-8.29687,0 -15,-6.70312 -15,-15c0,-8.29687 6.70313,-15 15,-15z"></path></g></g></svg>
                                                                <input class="filter-search" type="text" autocomplete="off" value={this.state.service_filter_search} onChange={(e) => this.setState({ service_filter_search: e.target.value }) }></input>
                                                            </label>
                                                            <label class="with-dropdown--menu__item">
                                                                <input class="hidden-input" type="checkbox" value="0" checked={this.state.selected_service_id == 0} onChange={(e) => { this.setState({ selected_service_id: Number(e.target.value), current_page: 1, selected_date: "", need_to_init: true }); this.resetSelections(this.state.selected_business_unit_id != 0 ? this.state.selected_business_unit_id : null); }}></input>
                                                                <span>Услуга</span>
                                                            </label>
                                                            {Object.entries(this.state.services).filter((srv) => srvs.includes(srv[0])).filter((srv) => this.state.service_filter_search === "" ? true : srv[1].srv_name.toLowerCase().includes(this.state.service_filter_search.toLowerCase())).sort((a, b) => a[1].srv_name.localeCompare(b[1].srv_name)).map((srv) =>
                                                            <label class="with-dropdown--menu__item" key={srv[0]}>
                                                                <input class="hidden-input" type="checkbox" value={srv[0]} checked={this.state.selected_service_id == srv[0]} onChange={(e) => { this.setState({ selected_service_id: Number(e.target.value), current_page: 1, selected_date: "", need_to_init: true }); this.resetSelections(this.state.selected_business_unit_id != 0 ? this.state.selected_business_unit_id : null); }}></input>
                                                                <span>{srv[1].srv_name}</span>
                                                            </label>)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                    <p class="filter-mobile-icon">
                                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.56326 0.000113221C6.59768 0.000179888 6.63216 0.000235345 6.66667 0.000235345C6.70122 0.000235345 6.73567 0.000179888 6.77011 0.000113221C7.17978 -0.000564556 7.58245 -0.00123153 7.94111 0.0948796C8.89978 0.351735 9.64844 1.10048 9.90533 2.05907C10.0014 2.41778 10.0008 2.82046 10.0001 3.23015C10.0001 3.26458 10 3.29906 10 3.33357H18.8889C19.5026 3.33357 20 3.83102 20 4.44468C20 5.05832 19.5026 5.55579 18.8889 5.55579H10C10 5.5903 10.0001 5.62478 10.0001 5.65921C10.0008 6.0689 10.0014 6.47158 9.90533 6.83034C9.64844 7.78889 8.89978 8.53767 7.94111 8.79445C7.58245 8.89056 7.17978 8.88989 6.77011 8.88923C6.73567 8.88923 6.70122 8.88911 6.66667 8.88911C6.63216 8.88911 6.59768 8.88923 6.56325 8.88923C6.15356 8.88989 5.75088 8.89056 5.39217 8.79445C4.43358 8.53767 3.68483 7.78889 3.42799 6.83034C3.33187 6.47157 3.33253 6.0689 3.33322 5.6592C3.33328 5.62478 3.33333 5.59029 3.33333 5.55579H1.11111C0.497467 5.55579 0 5.05832 0 4.44468C0 3.83102 0.497467 3.33357 1.11111 3.33357H3.33333C3.33333 3.29906 3.33328 3.26458 3.33322 3.23015C3.33253 2.82046 3.33187 2.41778 3.42799 2.05907C3.68483 1.10048 4.43358 0.351735 5.39217 0.0948796C5.75088 -0.00123153 6.15356 -0.000564556 6.56326 0.000113221ZM6.10957 2.2284C5.99106 2.2338 5.96317 2.2425 5.96732 2.24138C5.7756 2.29276 5.62586 2.4425 5.57449 2.63422C5.57356 2.63812 5.56626 2.67226 5.5615 2.77646C5.55582 2.90094 5.55556 3.06517 5.55556 3.33357V5.55579C5.55556 5.82418 5.55582 5.98841 5.5615 6.11289C5.5669 6.2314 5.5756 6.25928 5.57449 6.25514C5.62586 6.44685 5.7756 6.5966 5.96732 6.64797C5.96317 6.64686 5.99106 6.65555 6.10957 6.66096C6.23403 6.66664 6.39827 6.66689 6.66667 6.66689C6.93511 6.66689 7.09933 6.66664 7.22378 6.66096C7.34222 6.65555 7.37011 6.64686 7.366 6.64797C7.55778 6.5966 7.70744 6.44685 7.75889 6.25514C7.75778 6.25928 7.76645 6.2314 7.77178 6.11289C7.77756 5.98841 7.77778 5.82418 7.77778 5.55579V3.33357C7.77778 3.06517 7.77756 2.90094 7.77178 2.77646C7.76645 2.65796 7.75778 2.63007 7.75889 2.63422M6.10957 2.2284C6.23403 2.22272 6.39827 2.22246 6.66667 2.22246L6.10957 2.2284ZM6.66667 2.22246C6.93511 2.22246 7.09933 2.22272 7.22378 2.2284L6.66667 2.22246ZM7.22378 2.2284C7.328 2.23315 7.36211 2.24045 7.366 2.24138L7.22378 2.2284ZM13.2299 8.889C13.2643 8.88911 13.2988 8.88911 13.3333 8.88911C13.3679 8.88911 13.4023 8.88911 13.4368 8.889C13.8464 8.88834 14.2491 8.88767 14.6078 8.98378C15.5664 9.24067 16.3151 9.98934 16.572 10.948C16.6681 11.3067 16.6674 11.7093 16.6668 12.119C16.6668 12.1534 16.6667 12.1879 16.6667 12.2224H18.8889C19.5026 12.2224 20 12.7199 20 13.3336C20 13.9472 19.5026 14.4447 18.8889 14.4447H16.6667C16.6667 14.4792 16.6668 14.5137 16.6668 14.5481C16.6674 14.9578 16.6681 15.3604 16.572 15.7192C16.3151 16.6778 15.5664 17.4266 14.6078 17.6833C14.2491 17.7794 13.8464 17.7788 13.4368 17.7781C13.4023 17.7781 13.3679 17.778 13.3333 17.778C13.2988 17.778 13.2643 17.7781 13.2299 17.7781C12.8202 17.7788 12.4176 17.7794 12.0589 17.6833C11.1002 17.4266 10.3516 16.6778 10.0947 15.7192C9.99856 15.3604 9.99922 14.9578 9.99989 14.5481C9.99989 14.5137 10 14.4792 10 14.4447H1.11111C0.497467 14.4447 0 13.9472 0 13.3336C0 12.7199 0.497467 12.2224 1.11111 12.2224H10C10 12.188 9.99989 12.1534 9.99989 12.119C9.99922 11.7093 9.99856 11.3067 10.0947 10.948C10.3516 9.98934 11.1002 9.24067 12.0589 8.98378C12.4176 8.88767 12.8202 8.88834 13.2299 8.889ZM12.7762 11.1173C12.6578 11.1227 12.6299 11.1313 12.634 11.1302C12.4422 11.1817 12.2926 11.3314 12.2411 11.5231C12.2422 11.519 12.2336 11.5469 12.2282 11.6653C12.2224 11.7898 12.2222 11.9541 12.2222 12.2224V14.4447C12.2222 14.7131 12.2224 14.8773 12.2282 15.0018C12.2336 15.1203 12.2422 15.1482 12.2411 15.144C12.2926 15.3358 12.4422 15.4854 12.634 15.5369C12.6299 15.5358 12.6578 15.5444 12.7762 15.5499C12.9007 15.5556 13.0649 15.5558 13.3333 15.5558C13.6018 15.5558 13.766 15.5556 13.8904 15.5499C14.0089 15.5444 14.0368 15.5358 14.0327 15.5369C14.2244 15.4854 14.3741 15.3358 14.4256 15.144C14.4244 15.1482 14.4331 15.1203 14.4384 15.0018C14.4442 14.8773 14.4444 14.7131 14.4444 14.4447V12.2224C14.4444 11.9541 14.4442 11.7898 14.4384 11.6653C14.4331 11.5469 14.4244 11.519 14.4256 11.5231C14.3741 11.3314 14.2244 11.1817 14.0327 11.1302C14.0368 11.1313 14.0089 11.1227 13.8904 11.1173C13.766 11.1116 13.6018 11.1113 13.3333 11.1113C13.0649 11.1113 12.9007 11.1116 12.7762 11.1173Z" fill="#D30D15"/>
                                        </svg>
                                        <span>
                                            ФИЛЬТР
                                        </span>
                                        <span>
                                            {(this.state.selected_business_unit_id != 0 ? 1 : 0) + (this.state.selected_specialization_id != 0 ? 1 : 0) + (this.state.selected_service_id != 0 ? 1 : 0)}
                                        </span>
                                    </p>
                                    {entries.slice(this.state.current_page * page_size - page_size, this.state.current_page * page_size).map((entry) =>
                                    <div class="appointment-list--item" key={entry[0]} data-key={entry[0]}>
                                        <div class="appointment-list--item__doctor">
                                                {entry[1].avatar && entry[1].avatar.length > 0 && <div style={{backgroundImage: `url(data:image/jpeg;base64,${entry[1].avatar})`}} class="photo"></div>}
                                                {(entry[1].avatar === undefined || entry[1].avatar.length === 0) && <div class="photo-null">{((entry[1].fio && entry[1].fio.length > 0) ? entry[1].fio.charAt(0) : 'X') +
                                                                            ((entry[1].fio && entry[1].fio.length > entry[1].fio.indexOf(" ")) ? entry[1].fio.charAt((entry[1].fio.indexOf(" ") + 1)) : 'Y')}</div>}
                                            <div class="info">
                                                <p class="name">
                                                    {entry[1].fio}
                                                </p>
                                                <p class="specialization post">
                                                    {Object.values(entry[1].sps).map((sp, index) =>
                                                        <span>{(index !== 0 ? ", " : "") + sp.sp_name}</span>
                                                    )}
                                                </p>
                                                <a href="#" class={entry[1].profile.QINFO ? "about" : "about inactive-descr-link"} data-key={entry[0]} onClick={this.openDescription}>О специалисте</a>
                                                {this.state.selected_business_unit_id == 0 &&
                                                <div class="appointment-make--row" style={{"margin-top": "1rem", "margin-bottom": "0rem"}}>
                                                    <div class={entry[1].selected_bu != 0 ? "value with-dropdown filled no-icon" : "value with-dropdown no-icon"} data-placeholder="Выбрать филиал">
                                                        <span class={entry[1].selected_bu != 0 ? "with-dropdown--title filled" : "with-dropdown--title"}>{entry[1].selected_bu != 0 ? this.state.business_units[entry[1].selected_bu].bu_name : "Выбрать филиал"}</span>
                                                        <div class="with-dropdown--menu">
                                                            <div class="with-dropdown--menu__inner">
                                                                <div class="scroll">
                                                                    {Object.entries(entry[1].bus).map((bu) =>
                                                                    <label class="with-dropdown--menu__item" key={bu[0]}>
                                                                        <input name="business-unit" class="hidden-input" type="radio" value={bu[0]} checked={entry[1].selected_bu == bu[0]} onChange={(e) => { let united = this.state.united; united[entry[0]].selected_bu = e.target.value; united[entry[0]].selected_date = 0; united[entry[0]].selected_time = -1; this.setState({united: united, need_to_init: true}); }}></input>
                                                                        <span style={entry[1].selected_bu == bu[0] ? {"color": "#d30d15", "font-weight": "700"} : {}}>
                                                                            {bu[1].bu_name}
                                                                        </span>
                                                                    </label>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {Object.entries(entry[1].bus).length > 1 &&
                                                        <div class="another-unit">Выбрать другой филиал</div>}
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                        {!entry[1].loaded && <div class="no-schedule-container"><div class="no-schedule-inner loading-schedule">Расписание загружается</div></div>}
                                        {entry[1].loaded && (schedule[entry[0]] == undefined || Object.entries(schedule[entry[0]]).length === 0) && <div class="no-schedule-container"><div class="no-schedule-inner">Нет доступного для записи времени в данном филиале. Попробуйте изменить филиал или получите дополнительную информацию по телефону <a href={entry[1].selected_bu && this.state.business_units[Number(entry[1].selected_bu)] && this.state.business_units[Number(entry[1].selected_bu)].tel ? ("tel:" + this.state.business_units[Number(entry[1].selected_bu)].tel) : "tel:2000-451"}>{entry[1].selected_bu && this.state.business_units[Number(entry[1].selected_bu)] && this.state.business_units[Number(entry[1].selected_bu)].tel ? this.state.business_units[Number(entry[1].selected_bu)].tel : "2000-451"}</a></div></div>}
                                        {entry[1].loaded && schedule[entry[0]] != undefined && Object.entries(schedule[entry[0]]) &&
                                            <div class="appointment-list--item__schedule">
                                                <div class="swiper-scrollbar"></div>
                                                <div class="dates swiper" doctorIndex={entry[0]}>
                                                    <div class="swiper-wrapper">
                                                        {schedule[entry[0]] != undefined && Object.entries(schedule[entry[0]]).length && Object.entries(schedule[entry[0]]).filter((data, index) => index == entry[1].selected_date).length &&
                                                                Object.entries(schedule[entry[0]]).map((date, index) =>
                                                        <div class={entry[1].selected_date == index ? "swiper-slide swiper-slide-current" : "swiper-slide swiper-slide-not-current"} key={index} data-id={entry[0]} data-index={index} onClick={this.changeDate}>
                                                            {this.getDayName(parseInt(date[0][0] + date[0][1] + date[0][2] + date[0][3]), parseInt(date[0][8] + date[0][9]), parseInt(date[0][5] + date[0][6])).toUpperCase()}, {date[0][8] + date[0][9] + "." + date[0][5] + date[0][6]}
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div class="times swiper">
                                                    <div class="swiper-wrapper">
                                                        <div class="swiper-slide">
                                                            {schedule[entry[0]] != undefined && Object.entries(schedule[entry[0]]).length && Object.entries(schedule[entry[0]]).filter((data, index) => index == entry[1].selected_date).length &&
                                                                Object.keys(Object.entries(schedule[entry[0]]).filter((data, index) => index == entry[1].selected_date)[0][1]).map((time, index) =>
                                                            <div class={entry[1].selected_time == index ? "times--item active" : "times--item"} data-id={entry[0]} data-index={index} onClick={this.changeTime}>
                                                                <span>{time}</span>
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="navigation-item navigation-prev">
                                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="11.5" cy="11.5" r="11.5" transform="rotate(-180 11.5 11.5)" fill="#7E7E7E"/>
                                                        <path d="M14.7158 5.63439C14.3416 5.26016 13.7348 5.26016 13.3606 5.63439L8.6768 10.3228C7.92892 11.0714 7.92921 12.2845 8.67738 13.0327L13.364 17.7193C13.7382 18.0936 14.3451 18.0936 14.7193 17.7193C15.0936 17.3451 15.0936 16.7383 14.7193 16.364L10.7081 12.3528C10.3338 11.9786 10.3338 11.3717 10.7081 10.9975L14.7158 6.98966C15.0901 6.61543 15.0901 6.00871 14.7158 5.63439Z" fill="white"/>
                                                    </svg>
                                                </div>
                                                <div class="navigation-item navigation-next">
                                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="11.5" cy="11.5" r="11.5" fill="#7E7E7E"/>
                                                        <path d="M8.28415 17.3656C8.65839 17.7398 9.26521 17.7398 9.63944 17.3656L14.3232 12.6772C15.0711 11.9286 15.0708 10.7155 14.3226 9.96728L9.63599 5.28069C9.26176 4.90644 8.65494 4.90644 8.28069 5.28069C7.90644 5.65494 7.90644 6.26172 8.28069 6.63598L12.2919 10.6472C12.6662 11.0214 12.6662 11.6283 12.2919 12.0025L8.28415 16.0103C7.90989 16.3846 7.90989 16.9913 8.28415 17.3656Z" fill="white"/>
                                                    </svg>
                                                </div>
                                            </div>}
                                        <div class="appointment-list--item__action">
                                            <p class="price">{entry[1].profile.AVGPRICE ? ("Стоимость от " + entry[1].profile.AVGPRICE + " руб") : ""}</p>
                                            <button class="button-primary" data-index={entry[0]} onClick={this.toConfirmation}>
                                                Записаться
                                            </button>
                                        </div>
                                    </div>
                                    )}
                                    {pages > 1 &&
                                        <div className="appointment-pages">
                                            <span className="appointment-pages-left" style={{visibility: this.state.current_page > 1 ? "visible" : "hidden"}} onClick={(e) => this.setState({current_page: this.state.current_page - 1, need_to_init: true})}>{'<'}</span>
                                            {Array.from({ length: pages }, (_, index) => {
                                                    const pageNumber = index + 1;
                                                    return (
                                                      <span key={pageNumber} className={this.state.current_page === pageNumber ? ["appointment-page", "appointment-page-current"].join(' ') : "appointment-page"} onClick={(e) => {if(this.state.current_page != pageNumber) this.setState({current_page: pageNumber, need_to_init: true})}}>{pageNumber}</span>
                                                    );
                                                })
                                            }
                                            <span className="appointment-pages-right" style={{visibility: this.state.current_page < pages ? "visible" : "hidden"}} onClick={(e) => this.setState({current_page: this.state.current_page + 1, need_to_init: true})}>{'>'}</span>
                                        </div>
                                    }
                                    {entries.length == 0 &&
                                    <div>Нет свободного времени по указанным параметрам</div>}
                                </div>
                                <div id="doctor_description" class="modal">
                                    <div class="modal-content doctor-description-modal">
                                        <div class="modal-content--close">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.16699 22.8327L22.6159 1.38377M1.16699 1.16602L22.6159 22.6149" stroke="#D30D15" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        {this.state.open_description_for_doctor != 0 &&
                                        <div class="doctor-description-content">
                                            <h1>{this.state.united[this.state.open_description_for_doctor].profile.LNAME} {this.state.united[this.state.open_description_for_doctor].profile.FNAME} {this.state.united[this.state.open_description_for_doctor].profile.SNAME}</h1>
                                            <div class="doctor-description-container">
                                                <div>
                                                    {this.state.united[this.state.open_description_for_doctor].avatar && this.state.united[this.state.open_description_for_doctor].avatar.length > 0 && <div style={{backgroundImage: `url(data:image/jpeg;base64,${this.state.united[this.state.open_description_for_doctor].avatar})`}} class="doctor-description-photo"></div>}
                                                    {(this.state.united[this.state.open_description_for_doctor].avatar === undefined || this.state.united[this.state.open_description_for_doctor].avatar.length === 0) && <div class="doctor-description-photo-null">{((this.state.united[this.state.open_description_for_doctor].fio && this.state.united[this.state.open_description_for_doctor].fio.length > 0) ? this.state.united[this.state.open_description_for_doctor].fio.charAt(0) : 'X') +
                                                                                ((this.state.united[this.state.open_description_for_doctor].fio && this.state.united[this.state.open_description_for_doctor].fio.length > this.state.united[this.state.open_description_for_doctor].fio.indexOf(" ")) ? this.state.united[this.state.open_description_for_doctor].fio.charAt((this.state.united[this.state.open_description_for_doctor].fio.indexOf(" ") + 1)) : 'Y')}</div>}
                                                </div>
                                                <div>
                                                    <h2>{this.state.united[this.state.open_description_for_doctor].profile.QINFO}</h2>
                                                </div>
                                            </div>
                                            <div>
                                                Образование:
                                                <ul>
                                                    {this.state.united[this.state.open_description_for_doctor].profile.EDU.map((data, index) =>
                                                        <li key={index}>{data.edu_date} - {data.edu_org} по специальности «{data.edu_spec}»</li>
                                                    )}
                                                    {this.state.united[this.state.open_description_for_doctor].profile.SERTS.map((data, index) =>
                                                        <li key={index + this.state.united[this.state.open_description_for_doctor].profile.EDU.length}>
                                                            {data.serts_date} - {data.serts_org} по программе «{data.serts_sert}»
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }

    resetSelections = (bu) => {
        let united = this.state.united;
        for(let entry of Object.entries(united))
        {
            united[entry[0]].selected_bu = bu ? bu : (Object.keys(united[entry[0]].bus).length > 0 ? Object.keys(united[entry[0]].bus)[0] : 0);
            united[entry[0]].selected_date = 0;
            united[entry[0]].selected_time = -1;
        }
        this.setState({united: united});
    }

    changeDate = (e) => {
        let united = this.state.united;
        united[e.currentTarget.dataset.id].selected_date = e.currentTarget.dataset.index;
        united[e.currentTarget.dataset.id].selected_time = -1;
        this.setState({united: united});

        //Получаем объекты swipers
        let date_swipers = getDatesSwipers();

        //Свайпаем слайдер, чтобы выбор оказался в поле зрения
        if(date_swipers[e.currentTarget.dataset.id] != undefined)
            while(Math.abs(united[e.currentTarget.dataset.id].selected_date - date_swipers[e.currentTarget.dataset.id].activeIndex > 4) || date_swipers[e.currentTarget.dataset.id].activeIndex > united[e.currentTarget.dataset.id].selected_date)
            {
                if(united[e.currentTarget.dataset.id].selected_date > date_swipers[e.currentTarget.dataset.id].activeIndex)
                    date_swipers[e.currentTarget.dataset.id].slideNext();
                else
                    date_swipers[e.currentTarget.dataset.id].slidePrev();
            }
    }

    changeAllDates = (date, e) => {
        //Получаем список врачей с информацией о выборе
        let united = this.state.united;
        //Получаем объекты swipers
        let date_swipers = getDatesSwipers();
        for(let entry of Object.entries(united))
        {
            united[entry[0]].selected_date = (schedule[entry[0]] == undefined || Object.keys(schedule[entry[0]]).indexOf(date) == -1) ? 0 : Object.keys(schedule[entry[0]]).indexOf(date);
            united[entry[0]].selected_time = -1;

            //Свайпаем слайдер, чтобы выбор оказался в поле зрения
            if(date_swipers[entry[0]] != undefined)
                while(Math.abs(united[entry[0]].selected_date - date_swipers[entry[0]].activeIndex > 4) || date_swipers[entry[0]].activeIndex > united[entry[0]].selected_date)
                {
                    if(united[entry[0]].selected_date > date_swipers[entry[0]].activeIndex)
                        date_swipers[entry[0]].slideNext();
                    else
                        date_swipers[entry[0]].slidePrev();
                }
        }
        this.setState({united: united});
    }

    changeTime = (e) => {
        let united = this.state.united;
        united[e.currentTarget.dataset.id].selected_time = e.currentTarget.dataset.index;
        this.setState({united: united});
    }

    openDescription = (e) => {
        e.preventDefault();

        const form = document.getElementById("doctor_description");

        if(!e.target.classList.contains('inactive-descr-link')) {
            this.setState({open_description_for_doctor: parseInt(e.target.dataset.key)});
            if(form && !form.classList.contains('open'))
                form.classList.add('open');
        }
    }

    toConfirmation = (e) => {
        e.preventDefault();

        //Перебрасываем пользователя на страницу входа
        window.location = "/login/?from=" + encodeURIComponent(this.props.router.location.pathname + this.props.router.location.search);
    }
}

export default withRouter(Enroll);
